import { Button, Image } from '@belong/ui';
import { downloadURL } from 'lease-signing-flow-v2/constants/app';
import { LEASE_SIGNING_FLOW_STRINGS } from 'lease-signing-flow-v2/constants/strings';

export const DownloadAppButton = () => {
  const handleClick = () => window.open(downloadURL, '_blank');

  return (
    <Button onClick={handleClick}>
      <div className="mr-xs flex">
        <Image
          alt="app-store-icon"
          className="h-[16px] w-[16px] object-contain"
          src="icons/app-store.svg"
        />
      </div>
      <div className="mr-xs flex">
        <Image
          alt="play-store-icon"
          className="h-[16px] w-[16px] object-contain"
          src="icons/play-store.svg"
        />
      </div>
      {LEASE_SIGNING_FLOW_STRINGS['success.cta.download']}
    </Button>
  );
};
